export { default } from './FeaturedFrame';
